module.exports = __webpack_public_path__ + "static/media/portrait-2.8d481ca3.jpg";